"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationHeading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = require("../../tools/styled");
const Box_1 = require("../Box");
const NavigationHeading = ({ name, description, }) => {
    return (jsx_runtime_1.jsxs(Info, Object.assign({ color: "primaryText", backgroundColor: "primaryDark", display: "flex", flexDirection: "column" }, { children: [jsx_runtime_1.jsx(Box_1.Box, Object.assign({ fontWeight: "bold", flex: 1, padding: "1rem 2rem 0.05rem", fontSize: "0.95em" }, { children: name }), void 0),
            jsx_runtime_1.jsx(Box_1.Box, Object.assign({ fontWeight: 300, flex: 1, padding: "0 2rem 1rem", fontSize: "0.7rem" }, { children: description }), void 0)] }), void 0));
};
exports.NavigationHeading = NavigationHeading;
const Info = styled_1.styled(Box_1.Box) `
  text-transform: uppercase;

  a {
    color: inherit;
    font-weight: inherit;
  }

  .home {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 0.85em;

    a {
      margin: 0.5rem 1.5rem;
      padding: 0.5rem;
      display: block;
      &:hover {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 2px;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map